// v101.192.0 · Pestañas de «Gestión WhatsApp» (Negociaciones · Plantillas · Conexión) visibles dentro del módulo
import { NavLink } from "react-router-dom";
import { useAuth } from "../lib/auth";

const TABS = [
  { label: "Conversaciones (Fibi)", to: "/whatsapp/conversaciones" },   // v101.196.0
  { label: "Negociaciones", to: "/admin/a2-negotiations", roles: ["admin", "super_admin", "admin_zone", "supervisor"] },
  { label: "Plantillas WhatsApp", to: "/admin/whatsapp-templates", roles: ["admin", "super_admin"] },
  { label: "Conexión WhatsApp (Meta)", to: "/admin/whatsapp-conexion", roles: ["admin", "super_admin"] },
];

export default function WhatsAppTabs() {
  const { user } = useAuth() || {};
  const role = String(user?.role || "").toLowerCase();
  const tabs = TABS.filter(t => !t.roles || t.roles.includes(role));
  if (tabs.length < 2) return null;
  return (
    <nav className="flex flex-wrap gap-1 border-b" style={{ borderColor: "#CBD5E1", marginBottom: 16 }}
         data-testid="whatsapp-tabs">
      {tabs.map(t => (
        <NavLink key={t.to} to={t.to}
          className={({ isActive }) =>
            "px-4 py-2 text-xs font-semibold rounded-t-lg -mb-px border " +
            (isActive ? "bg-white text-emerald-700 border-slate-300 border-b-white"
                      : "text-slate-500 border-transparent hover:text-slate-800 hover:bg-white/60")}
          data-testid={`whatsapp-tab-${t.to.split("/").pop()}`}>
          {t.label}
        </NavLink>
      ))}
    </nav>
  );
}
